// Sidebar.jsx
import React, { useEffect, useRef } from "react";
import { Box, Typography, Divider } from "@mui/material";
import logo from "../assets/logo.png"; // adjust the path if needed
import { ReactComponent as NIHLogo } from "../assets/nih.svg";
import { ReactComponent as NSFLogo } from "../assets/NSF_logo.svg";
import AttributionBox from "./AttributionBox";

const Sidebar = ({ focusedElement, currentEnvironment, system }) => {
  const headerRef = useRef(null);

  useEffect(() => {
    console.log(currentEnvironment);
  }, [currentEnvironment]);

  useEffect(() => {
    if (!headerRef.current) return;

    const updateHeaderHeight = () => {
      const height = headerRef.current.getBoundingClientRect().height;
      document.documentElement.style.setProperty(
        "--app-header-height",
        `${Math.ceil(height)}px`
      );
    };

    updateHeaderHeight();

    const observer = new ResizeObserver(updateHeaderHeight);
    observer.observe(headerRef.current);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty("--app-header-height");
    };
  }, []);

  return (
    <Box>
      <Box
        className="sidebar-header"
        ref={headerRef}
        sx={{
          position: "absolute", // overlay on top of Unity web app
          top: 0,
          left: 0,
          width: "100%",
          backgroundColor: "#212121", // dark background
          color: "#fff",
          px: "var(--sidebar-header-px, 16px)", // overridable via CSS vars
          py: "var(--sidebar-header-py, 10px)",
          minHeight: "var(--sidebar-header-height, 80px)",
          zIndex: 1000, // ensure it appears on top
          overflowY: "auto",
          boxShadow: 3,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          columnGap: "var(--sidebar-header-gap, 12px)",
        }}
      >
        <Box width="33%" className="sidebar-header__left">
          <Box sx={{ pl: 0, pt: 1, mb: 0 }} align="left">
            <img
              src={logo}
              alt="Logo"
              className="sidebar-logo"
            />{" "}
          </Box>
        </Box>
        <Box width="33%" className="sidebar-header__center">
          {/* <Typography sx={{mb:0}} variant="caption">CURRENT EXPERIENCE</Typography> */}
          {system && (
            <h3>{system?.name}</h3>
            // <Card label="Experience" content={system?.name} color="#7CFDFF" />
          )}
        </Box>
        <Box width="34%" className="sidebar-header__right"></Box>

        {/* {currentEnvironment && (
        <Card
          label="Current environment"
          content={currentEnvironment.environmentName}
          description={currentEnvironment.description}
        />
      )} */}

        {/* {focusedElement && (
        <Card
          label="Selected element"
          variant="roundedColored"
          content={focusedElement.labelData.displayName}
          description={focusedElement.labelData.description}
        />
      )}
      {!focusedElement && (
        <Card
          label="Instructions"
          variant="rounded"
          content="Navigation"
          description="Scroll to zoom in and out. Click on objects to see more about them."
        />
      )}

      {!focusedElement && (
        <Card
          label="Instructions"
          variant="rounded"
          content="AI Guide"
          description="Enable your microphone to use the AI Guide. Answer the questions out loud and get an answer."
        />
      )} */}
      </Box>
      <AttributionBox />
    </Box>
  );
};

const Card = ({label, content, description, variant, color}) => {
  // Define variant-based styles
  const variantStyles = {
    roundedColored: {
      border: "1px solid rgba(255,255,255,0.12)",
      borderRadius: "10px",
      p: 2,
      pt: 0,
      pb: 2,
      backgroundColor: "#7CFDFF",
      color: "#333",
    },
    rounded: {
      border: "1px solid rgba(255,255,255,0.12)",
      borderRadius: "10px",
      p: 2,
      pt: 0,
      pb: 2,

    },
    default: {},
  };
  return (
    <Box
      sx={{
        color: color ? color : "inherit",
        pl: 2,
    
        mb: 3,
        ...variantStyles[variant],
      }}
      align="left"
    >
      <Typography variant="overline" gutterBottom color="inherit">
        {label}
      </Typography>
      <Typography variant={variant ? "h5" : "h4"} gutterBottom color="inherit">
        {content}
      </Typography>
      <Typography variant="body1" align="left" color="inherit">
        {description}
      </Typography>
      {/* {!variant && <Divider variant="fullWidth" sx={{ borderColor: "rgba(255,255,255,0.12)", margin: 2 }} />} */}
    </Box>
  );
}

export default Sidebar;
